import React from 'react';
import { useHistory } from 'react-router';
import Form from '@dashboard/components/Formik/Form';
import { toast } from '@dashboard/context/ToastContext';
import { useAdminTemplateCategoriesAll } from '@dashboard/hooks/queries/useAdminQueries';
import { useCreateTemplate } from '@dashboard/hooks/queries/useAdminMutations';

const TemplateAdd = () => {
  const history = useHistory();

  const { data: categories } = useAdminTemplateCategoriesAll();
  const createTemplateMutation = useCreateTemplate();

  return (
    <div className="max-w-xl mx-auto mt-16">
      <h1 className="text-lg font-bold mb-4">Add Template</h1>
      <Form
        initialValues={{
          title: '',
          page: '',
          category: '',
          publicTitle: '',
          publicDescription: '',
          displayAsUpsell: false,
          order: '',
          keywords: '',
        }}
        fields={[
          {
            name: 'title',
            required: true,
            type: 'text',
            label: 'Template title',
          },
          {
            name: 'page',
            required: true,
            type: 'text',
            label: 'Checkout ID',
          },
          {
            name: 'category',
            required: true,
            type: 'select',
            label: 'Category',
            options: [
              {
                label: 'Select a category',
                value: '',
              },
              ...(categories?.map(category => ({
                label: category.title,
                value: category._id,
              })) || []),
            ],
          },
          {
            name: 'displayAsUpsell',
            required: false,
            type: 'checkbox',
            label: 'Display as upsell',
          },
          {
            name: 'publicTitle',
            required: false,
            type: 'text',
            label: 'Page title',
          },
          {
            name: 'publicDescription',
            required: false,
            type: 'textarea',
            label: 'Page description',
            minRows: 8,
            autosize: true,
          },
          {
            name: 'order',
            required: false,
            type: 'number',
            label: 'Order',
            placeholder: 'Automatically generated if left empty',
          },
          {
            name: 'keywords',
            required: false,
            type: 'text',
            label: 'Keywords',
            tooltip: 'Used to generate content with GPT-3.5',
          },
        ]}
        showState={false}
        onSubmit={async values => {
          const response = await createTemplateMutation.mutateAsync(values);

          return {
            data: response,
            error: null,
            onSuccess: () => {
              toast({
                title: 'Template added',
              });
              history.push(`/admin/templates/${response._id}`);
            },
          };
        }}
        submitButton={{
          label: 'Create template',
        }}
      />
    </div>
  );
};

export default TemplateAdd;
